import React from 'react'
import { isMobile } from 'react-device-detect'

export const GuideToUse = () => {
  return isMobile ? (
    <>
      {' '}
      <div className="w-[335px] h-auto p-[40px]  bg-[#E7F9F7] flex flex-col items-center gap-[10px] border rounded-[20px] mt-[40px] px-5 py-8">
        <div className="flex flex-col items-center gap-[4px]">
          <p className="text-[#2E343D] font-bold leading-[28.8px] text-center text-[20px] md:text-[24px]">
            💁🏻 패스트컷 필수 사용팁 총정리
          </p>
          <p className="text-main text-[12px] font-bold">
            헷갈릴 땐 이 팁들부터! 패스트컷 사용이 훨씬 쉬워집니다.
          </p>
        </div>
        <div className=" w-full flex flex-col gap-6 items-start text-base">
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/coupang.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/coupangpartnersguide/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                쿠팡 파트너스 수익 만들기
              </a>
              <p className="text-[14px]">
                쿠팡 파트너스 처음이라면 여기서 시작하세요!
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center ">
            <img
              src="/assets/img/logo/ali.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/aliexpressaffiliatteguide/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                알리 어필리에이트 쉽게 시작하기
              </a>
              <p className="text-[14px]">시작부터 세팅까지 한 눈에!</p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/shorts.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeshortsupload/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                컨텐츠 영상 업로드, 이대로 따라만 하세요
              </a>
              <p className="text-[14px]">1분만에 끝나는 업로드 과정</p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/premium.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/paeseuteukeosai-peuro-peurimieom-gaideu/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                프리미엄 플랜 전용 업로드 가이드
              </a>
              <p className="text-[14px] font-normal">
                유튜브 직접 업로드 완벽하게!
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/youtube.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                유튜브 채널 권한 설정 필수 체크
              </a>
              <p className="text-[14px] font-normal">
                유튜브 채널 권한 설정 가이드
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/youtube.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeadvancedverification/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                유튜브 고급기능 신청법
              </a>
              <p className="text-[14px] font-normal">
                유튜브 채널 권한 설정 가이드
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/fastcut.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                패스트컷 100% 활용법
              </a>
              <p className="text-[14px] font-normal">
                이거 안보고 패스트컷 시작하면 손해
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/light.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeuploadguide/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                라이트플랜 영상 업로드 가이드
              </a>
              <p className="text-[14px] font-normal">
                라이트플랜 영상 업로드 방법 가이드
              </p>
            </div>
          </p>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="w-full h-auto p-[40px]  bg-[#E7F9F7] flex flex-col items-center gap-[10px] border rounded-[20px] mt-[40px]">
        <div className="flex flex-col items-center gap-[4px]">
          <p className="text-[#2E343D] font-bold leading-[28.8px] text-center text-[18px] md:text-[24px]">
            💁🏻 패스트컷 필수 사용팁 총정리
          </p>
          <p className="text-main text-[10px] md:text-[18px] font-bold">
            헷갈릴 땐 이 팁들부터! 패스트컷 사용이 훨씬 쉬워집니다.
          </p>
        </div>
        <div className="w-[660px] flex justify-between">
          <div className="flex flex-col gap-[16px]">
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/coupang.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/coupangpartnersguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  쿠팡 파트너스 수익 만들기
                </a>
                <p className="text-[14px]">
                  쿠팡 파트너스 처음이라면 여기서 시작하세요!
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center ">
              <img
                src="/assets/img/logo/ali.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/aliexpressaffiliatteguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  알리 어필리에이트 쉽게 시작하기
                </a>
                <p className="text-[14px]">시작부터 세팅까지 한 눈에!</p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/shorts.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeshortsupload/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  컨텐츠 영상 업로드, 이대로 따라만 하세요
                </a>
                <p className="text-[14px]">1분만에 끝나는 업로드 과정</p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/premium.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/paeseuteukeosai-peuro-peurimieom-gaideu/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  프리미엄 플랜 전용 업로드 가이드
                </a>
                <p className="text-[14px] font-normal">
                  유튜브 직접 업로드 완벽하게!
                </p>
              </div>
            </p>
          </div>
          <div className="flex flex-col gap-[16px]">
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/youtube.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  유튜브 채널 권한 설정 필수 체크
                </a>
                <p className="text-[14px] font-normal">
                  유튜브 채널 권한 설정 가이드
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/youtube.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeadvancedverification/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  유튜브 고급기능 신청법
                </a>
                <p className="text-[14px] font-normal">
                  유튜브 채널 권한 설정 가이드
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/fastcut.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  패스트컷 100% 활용법
                </a>
                <p className="text-[14px] font-normal">
                  이거 안보고 패스트컷 시작하면 손해
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/light.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeuploadguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  라이트플랜 영상 업로드 가이드
                </a>
                <p className="text-[14px] font-normal">
                  라이트플랜 영상 업로드 방법 가이드
                </p>
              </div>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
